<template>
  <header :class="$style.container">
    <div :class="$style.title">
      <TextComponent as="h1" type="heading2">{{ title }}</TextComponent>
      <TextComponent type="heading3" v-if="subtitle" as="p">
        {{ subtitle }}
      </TextComponent>
    </div>
    <Stack :class="$style.actions" v-if="$slots.default">
      <slot />
    </Stack>
  </header>
</template>

<script>
import Stack from '@hackthe6ix/vue-ui/Stack';
import Text from '@hackthe6ix/vue-ui/Text';

export default {
  name: 'Header',
  components: {
    TextComponent: Text,
    Stack,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: String,
    actions: Array,
  },
};
</script>

<style src="./Header.module.scss" lang="scss" module />
